module.exports = __webpack_public_path__ + "img/hakhak_card.f734200d.png";